import { FlexBox } from "@brg/ui";
import { FC, ReactNode, useMemo } from "react";

export const ActionsTools: FC<{
    repost?: ReactNode,
    bookmark?: ReactNode,
    remove?: ReactNode,
    select?: ReactNode,
    more?: ReactNode,
    status?: ReactNode,
    statusText?: ReactNode,
    actionsVisible: Record<string, boolean | undefined>
}> = ({
    repost,
    bookmark,
    remove,
    select,
    more,
    status,
    statusText,
    actionsVisible
}) => {
    const { 
        showStatus,
        showStatusText,
        showMore,
        showBookmark,
        showRemove,
        showRepost,
        showSelect,
        showBannedStatus,
        loading 
    } = actionsVisible;

    if (loading) return null;

    const leftSide = useMemo(() => {
        if (!showStatusText && !showStatus && !showMore) {
            return <div />
        }
        return (
            <>
                {showStatusText && statusText}
                {showMore && more}
                {showStatus && !showBannedStatus && status}
                {showSelect && select}
            </>
        )
    } ,[showStatusText, showStatus, showMore, showSelect, select,statusText, status, more])

    const rightSide = useMemo(() => {
        if (!showRepost && !showBookmark && !showRemove && !showSelect) {
            return <div />
        }
        return (
            <>
                {showBannedStatus && status}
                {showRepost && repost}
                {showBookmark && bookmark}
                {showRemove && remove}
            </>
        )
    } ,[showRepost, showBookmark, showRemove, repost, bookmark, remove])

    return (
        <FlexBox 
            width={'100%'} 
            className={`meta-card-actions`} 
            direction="row" 
            justify="space-between"
        >
            <FlexBox gx={8}>
                {leftSide}
            </FlexBox>
            <FlexBox gx={8}>
                {rightSide}
            </FlexBox>
        </FlexBox>
    )
}import { FlexBox } from "@brg/ui";
import { FC, ReactNode, useMemo } from "react";

export const ActionsTools: FC<{
    repost?: ReactNode,
    bookmark?: ReactNode,
    remove?: ReactNode,
    select?: ReactNode,
    more?: ReactNode,
    status?: ReactNode,
    statusText?: ReactNode,
    actionsVisible: Record<string, boolean | undefined>
}> = ({
    repost,
    bookmark,
    remove,
    select,
    more,
    status,
    statusText,
    actionsVisible
}) => {
    const { 
        showStatus,
        showStatusText,
        showMore,
        showBookmark,
        showRemove,
        showRepost,
        showSelect,
        showBannedStatus,
        loading 
    } = actionsVisible;

    if (loading) return null;

    const leftSide = useMemo(() => {
        if (!showStatusText && !showStatus && !showMore) {
            return <div />
        }
        return (
            <>
                {showStatusText && statusText}
                {showMore && more}
                {showStatus && !showBannedStatus && status}
                {showSelect && select}
            </>
        )
    } ,[showStatusText, showStatus, showMore, showSelect, select,statusText, status, more])

    const rightSide = useMemo(() => {
        if (!showRepost && !showBookmark && !showRemove && !showSelect) {
            return <div />
        }
        return (
            <>
                {showBannedStatus && status}
                {showRepost && repost}
                {showBookmark && bookmark}
                {showRemove && remove}
            </>
        )
    } ,[showRepost, showBookmark, showRemove, repost, bookmark, remove])

    return (
        <FlexBox 
            width={'100%'} 
            className={`meta-card-actions`} 
            direction="row" 
            justify="space-between"
        >
            <FlexBox gx={8}>
                {leftSide}
            </FlexBox>
            <FlexBox gx={8}>
                {rightSide}
            </FlexBox>
        </FlexBox>
    )
}